import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader } from 'antd';
import PoiPreferencesContainer from './PoiPreferencesContainer';
import CustomPoiContainer from './CustomPoiContainer';
import {
  reset,
  setSelectedCustomPoi,
  setSelectedCustomPoiIds
} from '../../../redux/slice/poiAdmin/poiAdmin';
import { getSelectedCustomPoi } from '../../../redux/selectors/poiAdmin';
import CustomPoiDrawer from './CustomPoiDrawer';
import PoiNotificationsContainer from './PoiNotificationsContainer';

const PoiContainer = () => {
  const { organisationId } = useParams<{ organisationId: string }>();
  const dispatch = useDispatch();
  const selectedCustomPoi = useSelector(getSelectedCustomPoi);

  const [customPoiDrawerVisible, setCustomPoiDrawerVisible] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, []);

  useEffect(() => {
    if (selectedCustomPoi) {
      setCustomPoiDrawerVisible(true);
    }
  }, [selectedCustomPoi]);

  return (
    <div className="px-5 py-3" style={{ height: '100%', overflow: 'auto' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'left',
          flexDirection: 'column',
          width: '100%'
        }}
      >
        <PageHeader
          className="site-page-header"
          style={{ paddingLeft: '0px' }}
          title="Locations"
          subTitle=""
        />

        <PoiNotificationsContainer />
        <PoiPreferencesContainer organisationId={organisationId} />
        <CustomPoiContainer organisationId={organisationId} />

        {customPoiDrawerVisible && (
          <CustomPoiDrawer
            onClose={() => {
              setCustomPoiDrawerVisible(false);
              dispatch(setSelectedCustomPoi(undefined));
              dispatch(setSelectedCustomPoiIds([]));
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PoiContainer;
